import { render, staticRenderFns } from "./customRadioButton.vue?vue&type=template&id=94038dac"
import script from "./customRadioButton.vue?vue&type=script&lang=js"
export * from "./customRadioButton.vue?vue&type=script&lang=js"
import style0 from "./customRadioButton.vue?vue&type=style&index=0&id=94038dac&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports